module.exports = {"0":{"name":"Nil"},"1":{"name":"Low"},"2":{"name":"Moderate"},"3":{"name":"High"},"4":{"name":"Very High"},"5":{"name":"Extreme"}}


//////////////////
// WEBPACK FOOTER
// ./src/config/hazard_values.json
// module id = 613
// module chunks = 0